import i from "@babel/runtime/helpers/esm/objectSpread2";
import G from "@babel/runtime/helpers/esm/objectWithoutProperties";
import N from "@babel/runtime/helpers/esm/slicedToArray";
import { sstyled as W } from "@semcore/utils/lib/core/index";
import r from "react";
import h from "classnames";
import { sstyled as B } from "@semcore/core";
import b, { removeUndefinedKeys as $ } from "../Box/useBox.mjs";
import { getAutoOrScaleIndent as _ } from "../utils.mjs";
var A = ["className", "style"], D = (
  /*__reshadow_css_start__*/
  (W.insert(
    /*__inner_css_start__*/
    ".___SFlex_1jwl7_gg_{display:flex}.___SFlex_1jwl7_gg_.__inline_1jwl7_gg_{display:inline-flex}",
    "1jwl7_gg_"
  ), {
    __SFlex: "___SFlex_1jwl7_gg_",
    _inline: "__inline_1jwl7_gg_"
  })
);
function O(e) {
  var n, l = {
    row: "row-reverse",
    column: "column-reverse"
  }, t = (n = e.scaleIndent) !== null && n !== void 0 ? n : 4;
  return $({
    alignItems: e.alignItems,
    alignContent: e.alignContent,
    justifyContent: e.justifyContent,
    flexWrap: e.flexWrap ? "wrap".concat(e.reverse ? "-reverse" : "") : void 0,
    flexDirection: e.reverse && l[e.direction] || e.direction,
    rowGap: _(e.rowGap || e.gap, t),
    columnGap: _(e.columnGap || e.gap, t)
  });
}
function E(e, n) {
  var l = b(i(i({
    "data-ui-name": "Flex"
  }, e), {}, {
    inline: !1
  }), n), t = N(l, 2), o = t[0], a = t[1], c = a.className, s = a.style, m = G(a, A), u = e.inline, g = e.flexWrap, d = e.direction, f = e.reverse, x = e.alignItems, v = e.alignContent, y = e.justifyContent, j = e.gap, w = e.rowGap, F = e.columnGap, I = e.scaleIndent, S = r.useMemo(function() {
    return O(e);
  }, [g, d, f, x, v, y, j, w, F, I]), C = B(D);
  return o === r.Fragment ? [r.Fragment, {
    children: e.children
  }] : [o, i({
    className: h(C.cn("SFlex", {
      inline: u
    }).className, c) || void 0,
    style: Object.assign({}, s, S)
  }, m)];
}
export {
  E as default
};
